<template>
  <v-row justify="center" class="text-center" style="position: relative">
    <v-col cols="8" sm="5">
      <v-card color="transparent" flat>
        <v-card-title class="font2 text-left font_wrap pa-0 pa-sm-3 pr-sm-6">
          Difficult to find developers?
          Spending hours and days to find a
          specialist?
        </v-card-title>
        <v-list color="transparent" class="mt-2">
          <v-list-item v-for="(item, i) in items" :key="i" class="px-0 px-sm-4">
            <v-list-item-icon class="mr-2 mr-sm-8">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  stroke="#F2518B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 10H9.01"
                  stroke="#F2518B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15 10H15.01"
                  stroke="#F2518B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.5 15.25C10.1583 14.5781 11.0594 14.1995 12 14.1995C12.9406 14.1995 13.8417 14.5781 14.5 15.25"
                  stroke="#F2518B"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                class="text-left font1 list_text"
                v-text="item.text"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-col>
    <v-col cols="4" sm="4" class="pa-0 pa-sm-3">
      <v-img
        aspect-ratio="1"
        contain
        class="img_person"
        :src="require('../../assets/HomeForHRs/2.png')"
      ></v-img>
    </v-col>
    <svg
      width="171"
      height="151"
      viewBox="0 0 171 151"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="svg_arrow"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.2426 63.9985C78.0325 61.426 74.2181 60.0494 71.217 59.178C42.4843 50.9583 23.0687 71.9837 12.1375 95.7301C9.20509 102.091 6.86094 112.834 8.6561 121.453C9.915 127.51 13.1693 132.534 19.4401 134.575C26.2679 136.825 34.0805 134.453 41.4787 129.873C52.1842 123.257 62.0474 112.067 66.6751 104.811C72.0102 96.4397 78.8453 82.6406 83.7454 68.3304C88.068 71.4627 92.7083 75.935 97.2206 82.4858C99.2367 85.3901 100.768 89.2085 101.832 93.4514C95.5364 95.6272 89.3907 99.1447 83.7093 104.049C78.9394 108.178 70.5534 118.726 67.0221 128.625C64.5069 135.693 64.5048 142.423 69.2598 146.679C75.1726 151.956 81.4832 151.31 87.1878 147.806C95.2227 142.878 101.982 132.07 104.221 125.429C106.821 117.7 107.159 105.737 105.07 95.3668C126.728 89.1343 149.695 99.2435 159.77 122.592C160.078 123.283 160.898 123.608 161.601 123.321C162.309 123.009 162.637 122.175 162.329 121.484C151.664 96.7824 127.371 86.0427 104.447 92.6108C103.305 88.0976 101.668 84.0052 99.5158 80.9001C94.5404 73.6875 89.4114 68.8602 84.6672 65.5638C85.5394 62.8674 86.3352 60.1599 87.0338 57.4646C90.1781 45.3613 91.268 33.7395 88.4002 25.5871C81.7757 6.74718 64.3612 -0.726051 46.2014 0.0551203C28.2154 0.835388 9.5628 9.72591 0.243007 23.375C-0.191004 24.0116 -0.0282343 24.8891 0.608201 25.3171C1.24489 25.7452 2.11264 25.5851 2.5464 24.9486C11.4149 11.9594 29.2083 3.56684 46.3201 2.84214C63.2583 2.11837 79.5892 8.94397 85.7701 26.5035C88.4879 34.2719 87.3212 45.2613 84.3342 56.7659C83.7123 59.1617 83.0106 61.572 82.2426 63.9985ZM102.453 96.2073C96.5768 98.288 90.8407 101.579 85.531 106.175C80.99 110.104 73.0146 120.115 69.6475 129.572C67.5601 135.433 67.1681 141.072 71.1191 144.591C75.9342 148.907 81.084 148.276 85.7317 145.423C93.2195 140.855 99.491 130.728 101.578 124.531C104.026 117.273 104.386 105.986 102.453 96.2073ZM81.3496 66.7178C77.1816 64.0995 73.4018 62.7278 70.4492 61.8634C43.2073 54.065 25.034 74.3888 14.6707 96.8966C11.9369 102.82 9.71421 112.83 11.3861 120.888C12.441 125.932 15.0683 130.218 20.3089 131.929C26.4265 133.947 33.3813 131.608 40.0093 127.512C50.3409 121.128 59.8592 110.303 64.3242 103.309C69.6599 94.937 76.5158 81.0633 81.3496 66.7178Z"
        fill="#F2518B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M160.418 120.919C159.177 120.224 155.598 118.233 155.048 117.948C153.506 117.155 152.62 116.977 151.699 116.896C150.96 116.842 150.184 116.885 148.816 116.611C148.061 116.451 147.327 116.967 147.18 117.722C147.032 118.478 147.529 119.196 148.284 119.356C149.526 119.587 150.331 119.625 151.037 119.649C151.85 119.688 152.477 119.752 153.776 120.43C154.41 120.755 157.743 122.942 159.456 123.628C160.35 123.99 161.062 123.963 161.393 123.83C161.865 123.638 162.342 123.241 162.725 122.571C163.214 121.71 163.641 120.218 164.156 118.557C164.638 116.996 165.215 115.241 166.117 113.765C166.882 112.529 167.878 111.508 169.343 111.148C170.091 110.971 170.554 110.235 170.377 109.485C170.2 108.734 169.447 108.264 168.699 108.441C166.488 108.952 164.9 110.432 163.742 112.311C162.718 113.975 162.038 115.948 161.492 117.734C161.16 118.799 160.88 119.795 160.587 120.555C160.54 120.678 160.48 120.798 160.418 120.919Z"
        fill="#F2518B"
      />
    </svg>
  </v-row>
</template>

<script>
export default {
  name: "SecondPage",
  data: () => ({
    items: [
      { text: "Spending too much time finding developer" },
      { text: "Unreliable and unskilled professionals" },
      { text: "Risky and expensive recruitment" },
      { text: "Result you won't like" },
    ],
  }),
};
</script>

<style scoped>
.img_person {
  max-width: 100%;
}
.svg_arrow {
  position: absolute;
  bottom: -10%;
}
.list_text {
  color: #565656;
  font-size: 1.1rem;
}
.font2 {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700 !important;
  font-size: 2rem;
  line-height: 3rem;
  color: #2b2b2b;
}
@media screen and (max-width: 400px) {
  .font2 {
    font-size: 1.1rem;
    line-height: 2rem;
  }
  .list_text {
    font-size: 0.8rem;
  }
  .svg_arrow {
    display: none;
  }
}
</style>